/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import sha1 from 'js-sha1';
import appboy from '@braze/web-sdk';

const brazeEmail = () => {
    const form = document.querySelector('#braze-form');

    if (!form) {
        return;
    }

    const emailInput = document.querySelector('#email');
    const tocInput = document.querySelector('#toc');

    const inputs = {
        firstName: form.querySelector('#firstName'),
        lastName: form.querySelector('#lastName'),
        email: form.querySelector('#email'),
        termsAccepted: form.querySelector('#toc'),
    };

    const getInputValues = () => {
        const values = {};
        Object.keys(inputs).forEach(key => {
            if (key === 'promo') {
                values[key] = inputs[key].checked;
            } else {
                values[key] = inputs[key].value;
            }
        });
        return values;
    };

    appboy.initialize(brazeVars.braze, {
        enableLogging: brazeVars.debug,
        baseUrl: 'https://customer.fra-01.braze.eu/api/v3',
    });
    const user = appboy.getUser();

    const showConfirmation = () => {
        const confirmDiv = document.querySelector('.confirm');
        form.style.display = 'none';
        confirmDiv.style.display = 'block';
    };

    const showError = type => {
        const errorDiv = document.querySelector('.error');

        if (errorDiv.hasChildNodes()) {
            const child = errorDiv.firstChild;
            errorDiv.removeChild(child);
        }

        let message;
        switch (type) {
        case 'empty':
            message = 'This field cannot be empty.';
            break;
        case 'invalid':
            message = 'Please enter a valid email address.';
            break;
        case 'terms':
            message = 'Please confirm you have read the terms and conditions.';
            break;
        default:
            message = 'Sorry, an unidentifiable error occurred. Please refresh the page and try again.';
        }

        const errorMessage = document.createElement('p');
        const messageNode = document.createTextNode(message);
        errorMessage.appendChild(messageNode);
        errorDiv.appendChild(errorMessage);

        emailInput.style.borderColor = '#EE2548';
    };

    const subscribeToGroup = async userEmail => {
        const formData = new FormData();
        formData.append('action', 'braze_subscribe_group');
        formData.append('email', userEmail);

        try {
            const response = await fetch(brazeVars.ajaxurl, {
                method: 'POST',
                body: formData,
            });
            await response.json();
        } catch (error) {
            console.log(error);
        }
    };

    const createBrazeUser = userEmail => {
        userEmail = userEmail.toLowerCase();
        const emailHash = sha1(userEmail); // hashing email for unique ID
        const inputValues = getInputValues();
        Object.keys(inputValues).forEach(key => { // Attaching form data to user object
            switch (key) {
            case 'email':
                user.setEmail(inputValues[key]);
                break;
            case 'firstName':
                user.setFirstName(inputValues[key]);
                break;
            case 'lastName':
                user.setLastName(inputValues[key]);
                break;
            default:
                user.setCustomUserAttribute(key, inputValues[key]);
            }
        });
        user.setEmailNotificationSubscriptionType(
            appboy.User.NotificationSubscriptionTypes.OPTED_IN,
        );
        appboy.changeUser(emailHash);
        subscribeToGroup(userEmail);
        showConfirmation();
    };

    form.addEventListener('submit', e => {
        e.preventDefault();
        const userEmail = emailInput.value;

        if (userEmail === '') {
            showError('empty');
        } else {
            createBrazeUser(userEmail);
            appboy.wipeData();
            appboy.destroy();
        }
    });

    emailInput.addEventListener('invalid', e => {
        e.preventDefault();
        showError('invalid');
    });

    tocInput.addEventListener('invalid', e => {
        e.preventDefault();
        showError('terms');
    });
};

brazeEmail();
